<template>
  <div style="position: relative">
    <v-card flat>
      <div id="controlsContainer">
        <div
          class="card-title table-controls px-3 d-flex align-center justify-space-between"
        >
          <div>
            <!-- CRUD buttons -->
          </div>
          <!-- center side -->
          <div>
            <!-- Search by fields -->
            <v-container id="filterContainer">
              <v-row>
                <v-col sm="12" lg="3" cols="12">
                  <v-dialog
                    v-model="modalFilterDateFrom"
                    :close-on-content-click="false"
                    persistent
                    width="290px"
                    @keydown.esc="modalFilterDateFrom = false"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="dateFromFormatted"
                        :label="$t('timeSlotsReservations.dateFrom')"
                        append-icon="far fa-calendar-alt"
                        readonly
                        clearable
                        required
                        v-on="on"
                        @click:clear="filter.dateFrom = null"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="filter.dateFrom"
                      scrollable
                      @input="modalFilterDateFrom = false"
                    >
                      <v-spacer></v-spacer>
                      <v-btn
                        text
                        color="primary"
                        @click="modalFilterDateFrom = false"
                      >
                        {{ $t("global.cancel") }}
                      </v-btn>
                    </v-date-picker>
                  </v-dialog>
                </v-col>
                <v-col sm="12" lg="3" cols="12">
                  <v-dialog
                    v-model="modalFilterDateTo"
                    :close-on-content-click="false"
                    persistent
                    width="290px"
                    @keydown.esc="modalFilterDateTo = false"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="dateToFormatted"
                        :label="$t('timeSlotsReservations.dateTo')"
                        append-icon="far fa-calendar-alt"
                        readonly
                        clearable
                        required
                        v-on="on"
                        @click:clear="filter.dateTo = null"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="filter.dateTo"
                      scrollable
                      @input="modalFilterDateTo = false"
                    >
                      <v-spacer></v-spacer>
                      <v-btn
                        text
                        color="primary"
                        @click="modalFilterDateTo = false"
                      >
                        {{ $t("global.cancel") }}
                      </v-btn>
                    </v-date-picker>
                  </v-dialog>
                </v-col>
                <v-col sm="12" lg="3" cols="12">
                  <v-text-field
                    v-model="filter.shippingNumber"
                    :label="$t('timeSlotsReservations.shippingNumber')"
                    clearable
                  ></v-text-field>
                </v-col>
                <v-col sm="12" lg="3" cols="12">
                  <v-text-field
                    v-model="filter.tokenTracking"
                    :label="$t('timeSlotsReservations.tokenTracking')"
                    clearable
                  ></v-text-field>
                </v-col>
                <v-col sm="12" lg="4" cols="12">
                  <v-text-field
                    v-model="filter.reference"
                    :label="$t('timeSlotsReservations.reference')"
                    clearable
                  ></v-text-field>
                </v-col>
                <v-col sm="12" lg="4" cols="12">
                  <v-text-field
                    v-model="filter.consigneeName"
                    :label="$t('timeSlotsReservations.consigneeName')"
                    clearable
                  ></v-text-field>
                </v-col>
                <v-col sm="12" lg="4" cols="12">
                  <v-select
                    v-model="filter.reservationType"
                    :items="reservationTypeValues"
                    :label="$t('timeSlotsReservations.type')"
                    clearable
                  ></v-select>
                </v-col>
              </v-row>
            </v-container>
          </div>
          <!-- right side -->
          <div>
            <!-- Refresh table -->
            <crud-button
              large
              color="blue"
              @clicked="search()"
              icon="fa-sync-alt"
              :tooltip="$t('global.crud.buttons.refreshTable')"
            />
          </div>
          <ExportExcel
            url="/timeSlotsReservations"
            :filter="this.filter"
            :filterExport="filterExport"
            :processFilter="processFilter"
            :itemsPerPage="10000"
          />
        </div>
      </div>
      <div id="dataContainer">
        <!-- Table -->
        <v-data-table
          :headers="headers"
          :items="items"
          :options.sync="options"
          :page.sync="pagination.page"
          :server-items-length="pagination.totalItems"
          :no-results-text="$t('global.datatable.noMatchingResults')"
          :no-data-text="$t('global.datatable.noDataAvailable')"
          :footer-props="{
            'items-per-page-options': rowsPerPageItems,
            'show-first-last-page': true,
            'show-current-page': true
          }"
          :loading="loading"
          light
          multi-sort
          dense
        >
          <template v-slot:body="{ items }">
            <tbody>
              <tr v-for="item in items" :key="item.token">
                <td>
                  <!-- Reschedule button -->
                  <crud-button
                    v-if="
                      $checkPermission('TIMESLOTSRESERVATIONS') &&
                        item.tokenTracking &&
                        item.countryReservation &&
                        item.postalCodeReservation
                    "
                    x-small
                    color="orange"
                    icon="fa-calendar-alt"
                    :tooltip="$t('timeSlotsReservations.reschedule')"
                    @clicked="reschedule(item)"
                  ></crud-button>
                </td>
                <td>{{ item.shippingNumber }}</td>
                <td>{{ item.reference }}</td>
                <td>{{ item.tokenTracking }}</td>
                <td>{{ item.token }}</td>
                <td>{{ transformDate(item.date, $t("global.dateFormat")) }}</td>
                <td>
                  {{ minutesToHour(item.hourFrom) }} -
                  {{ minutesToHour(item.hourTo) }}
                </td>
                <td>{{ minutesFormat(item.deliveryTime) }}</td>
                <td>
                  {{
                    transformDate(
                      item.creationDate,
                      $t("global.dateTimeFormat")
                    )
                  }}
                </td>
                <td>{{ item.reservationUser }}</td>
                <td>{{ getReservationTypeText(item.reservationType) }}</td>
                <td>
                  <a
                    :href="item.trackingUrl"
                    target="_blank"
                    v-if="item.trackingUrl"
                  >
                    {{ $t("timeSlotsReservations.tracking") }}
                  </a>
                </td>
              </tr>
            </tbody>
          </template>
        </v-data-table>
      </div>
    </v-card>

    <!-- Reschedule Dialog -->
    <v-dialog
      v-model="rescheduleDialog"
      max-width="800"
      persistent
      no-click-animation
    >
      <v-card>
        <v-toolbar dark color="primary" dense flat>
          <v-toolbar-title class="white--text">
            {{ $t("timeSlotsReservations.reschedule.title") }}
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click.native="closeReschedule()">
            <v-icon>fas fa-times</v-icon>
          </v-btn>
        </v-toolbar>

        <v-card-text class="details-list">
          <v-container>
            <v-row>
              <v-col cols="12">
                <h3>
                  {{ selectedItem.shippingNumber }} -
                  {{ selectedItem.reference }}
                </h3>
              </v-col>
            </v-row>
            <div v-if="availableSlots.length > 0">
              <template v-for="(dateGroup, index) in availableSlots">
                <v-row :key="index">
                  <v-col>
                    <v-card outlined class="grey lighten-3">
                      <v-card-text>
                        <v-row align="center">
                          <v-col cols="auto">
                            <time :datetime="dateGroup.date" class="icon">
                              <em class="blue--text">
                                {{ $d(Date.parse(dateGroup.date), "dayText") }}
                              </em>
                              <strong class="primary white--text">
                                {{
                                  $d(Date.parse(dateGroup.date), "monthText")
                                }}
                              </strong>
                              <span>
                                {{ $d(Date.parse(dateGroup.date), "dayShort") }}
                              </span>
                            </time>
                          </v-col>
                          <template v-for="range in dateGroup.rangeList">
                            <v-col :key="range.code" cols="auto">
                              <v-hover v-slot:default="{ hover }">
                                <v-card
                                  :elevation="hover ? 12 : 2"
                                  :color="
                                    selectedSlot &&
                                    selectedSlot.code === range.code &&
                                    selectedSlot.date === dateGroup.date
                                      ? 'primary'
                                      : 'default'
                                  "
                                  @click.native="
                                    selectSlot(range, dateGroup.date)
                                  "
                                  style="cursor: pointer;"
                                >
                                  <v-card-text
                                    :class="
                                      selectedSlot &&
                                      selectedSlot.code === range.code &&
                                      selectedSlot.date === dateGroup.date
                                        ? 'white--text'
                                        : ''
                                    "
                                  >
                                    {{ range.dateFrom }} -
                                    {{ range.dateTo }}
                                  </v-card-text>
                                </v-card>
                              </v-hover>
                            </v-col>
                          </template>
                        </v-row>
                      </v-card-text>
                    </v-card>
                  </v-col>
                </v-row>
              </template>
            </div>
            <v-row v-else-if="loadingSlots">
              <v-col cols="12" class="text-center">
                <v-progress-circular
                  indeterminate
                  color="primary"
                ></v-progress-circular>
                <p>{{ $t("timeSlotsReservations.reschedule.loading") }}</p>
              </v-col>
            </v-row>
            <v-row v-else>
              <v-col cols="12" class="text-center">
                <p>{{ $t("timeSlotsReservations.reschedule.noSlots") }}</p>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="black" text @click.native="closeReschedule()">
            {{ $t("global.buttons.close") }}
          </v-btn>
          <v-btn
            color="orange"
            text
            @click="confirmReschedule()"
            :disabled="!selectedSlot"
          >
            {{ $t("timeSlotsReservations.reschedule.confirm") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<style scoped>
.icon {
  font-size: 1em;
  display: block;
  position: relative;
  width: 7em;
  height: 7em;
  border-radius: 0.6em;
  box-shadow: 0 1px 0 #bdbdbd, 0 2px 0 #fff, 0 3px 0 #bdbdbd, 0 4px 0 #fff,
    0 5px 0 #bdbdbd, 0 0 0 1px #bdbdbd;
  overflow: hidden;
  backface-visibility: hidden;
}

.icon * {
  display: block;
  width: 100%;
  font-size: 1em;
  font-weight: bold;
  font-style: normal;
  text-align: center;
}

.icon strong {
  position: absolute;
  top: 0;
  padding: 0.4em 0;
}

.icon em {
  position: absolute;
  bottom: 0.1em;
}

.icon span {
  font-size: 2.8em;
  letter-spacing: -0.05em;
  padding-top: 1.15em;
  color: #2f2f2f;
}
</style>

<script>
import CrudButton from "@/components/Button.vue";
import { localhttp, trackinghttp } from "../js/https-commons";
import ExportExcel from "@/components/ExportExcel.vue";
import {
  transformDate,
  minutesToHour,
  minutesFormat,
  hourToMinutes
} from "@/js/utils.js";

const CONTEXT = "/timeSlotsReservations";
const CONTEXT_TIME_SLOTS = "/public/timeSlots";
const CONTEXT_TRACKING_EXPEDITIONS = "/public/expeditions";
const ENTITY_NAME = "timeSlotReservation.";

export default {
  components: {
    CrudButton,
    ExportExcel
  },
  name: "TimeSlotsReservations",
  data: () => ({
    loading: false,
    searched: false,
    items: [],
    options: {},
    pagination: {
      totalItems: 0,
      page: 1
    },
    rowsPerPageItems: [10, 20, 30, 40],
    modalFilterDateFrom: false,
    modalFilterDateTo: false,
    dateFromFormatted: "",
    dateToFormatted: "",
    filter: {
      dateFrom: null,
      dateTo: null,
      shippingNumber: "",
      tokenTracking: "",
      reference: "",
      consigneeName: "",
      type: ""
    },
    rescheduleDialog: false,
    selectedItem: {},
    availableSlots: [],
    loadingSlots: false,
    selectedSlot: null,
    selectedDay: null,
    scheludeToken: null,
    shippingNumber: null,
    shippingClient: null,
    shippingService: null,
    shippingDestinationPhone: null,
    countryReservation: null,
    postalCodeReservation: null,
    serviceReservation: null,
    resourceNumberWeight: null,
    resourceNumberVolumen: null,
    organizationCode: null,
    reference: null,
    senderName: null,
    consigneeName: null
  }),
  computed: {
    reservationTypeValues() {
      return [
        {
          text: this.$t("timeSlotsReservations.type.auto"),
          value: "AUTO"
        },
        {
          text: this.$t("timeSlotsReservations.type.consignee"),
          value: "CONSIGNEE"
        },
        {
          text: this.$t("timeSlotsReservations.type.manual"),
          value: "MANUAL"
        }
      ];
    },
    headers() {
      return [
        {
          text: this.$t("global.datatable.header.actions"),
          value: "actions",
          sortable: false
        },
        {
          text: this.$t("timeSlotsReservations.datatable.shippingNumber"),
          value: ENTITY_NAME + "shippingNumber",
          sortable: true
        },
        {
          text: this.$t("timeSlotsReservations.datatable.reference"),
          value: ENTITY_NAME + "reference",
          sortable: true
        },
        {
          text: this.$t("timeSlotsReservations.datatable.tokenTracking"),
          value: ENTITY_NAME + "tokenTracking",
          sortable: true
        },
        {
          text: this.$t("timeSlotsReservations.datatable.token"),
          value: ENTITY_NAME + "token",
          sortable: true
        },
        {
          text: this.$t("timeSlotsReservations.datatable.date"),
          value: ENTITY_NAME + "date",
          sortable: true
        },
        {
          text: this.$t("timeSlotsReservations.datatable.timeSlot"),
          value: ENTITY_NAME + "hourFrom",
          sortable: true
        },
        {
          text: this.$t("timeSlotsReservations.datatable.deliveryTime"),
          value: ENTITY_NAME + "deliveryTime",
          sortable: true
        },
        {
          text: this.$t("timeSlotsReservations.datatable.creationDate"),
          value: ENTITY_NAME + "creationDate",
          sortable: true
        },
        {
          text: this.$t("timeSlotsReservations.datatable.reservationUser"),
          value: ENTITY_NAME + "reservationUser",
          sortable: true
        },
        {
          text: this.$t("timeSlotsReservations.datatable.reservationType"),
          value: ENTITY_NAME + "reservationType",
          sortable: true
        },
        {
          text: this.$t("timeSlotsReservations.datatable.tracking"),
          value: "tracking",
          sortable: false
        }
      ];
    }
  },
  watch: {
    options: {
      handler() {
        if (this.searched) {
          this.search();
        }
      },
      deep: true
    },
    "pagination.totalItems": {
      handler() {
        this.pagination.page = 1;
      },
      deep: true
    },
    "filter.dateFrom": function() {
      this.dateFromFormatted = this.transformDate(
        this.filter.dateFrom,
        this.$t("global.dateFormat")
      );
    },
    "filter.dateTo": function() {
      this.dateToFormatted = this.transformDate(
        this.filter.dateTo,
        this.$t("global.dateFormat")
      );
    }
  },
  methods: {
    search() {
      console.debug("Search timeSlotsReservations");

      if (!this.filter.dateFrom || !this.filter.dateTo) {
        this.$showErrorMessage(
          this.$t("timeSlotsReservations.validation.datesRequired")
        );
        return;
      }

      this.searched = false;

      if (this.loading) return;

      this.loading = true;

      this.processFilter();

      localhttp
        .post(CONTEXT + "/allPagination", this.filter)
        .then(response => {
          this.pagination.totalItems = response.data.totalElements;
          this.items = response.data.content;
          this.loading = false;
          this.searched = true;
        })
        .catch(e => {
          console.log(e);
          this.loading = false;
          this.$showError();
        });
    },
    processFilter() {
      const { sortBy, sortDesc, page, itemsPerPage } = this.options;
      this.filter.sortBy = sortBy;
      this.filter.sortDesc = sortDesc;
      this.filter.page = page;
      this.filter.itemsPerPage = itemsPerPage;

      if (this.filter.sortDesc.length == 0) {
        this.filter.sortDesc.push("ASC");
      }
    },
    reschedule(item) {
      this.selectedItem = item;
      this.rescheduleDialog = true;
      this.loadAvailableSlots();
    },
    async loadAvailableSlots() {
      this.loadingSlots = true;
      this.availableSlots = [];

      let date;

      const tokenTracking = this.selectedItem.tokenTracking;
      this.countryReservation = this.selectedItem.countryReservation;
      this.postalCodeReservation = this.selectedItem.postalCodeReservation;

      await trackinghttp
        .get(
          `${CONTEXT_TRACKING_EXPEDITIONS}/${tokenTracking}/${this.postalCodeReservation}`
        )
        .then(response => {
          date = this.transformDate(
            response.data.requestedDeliveryDateFrom,
            "YYYY-MM-DD"
          );
          this.organizationCode = response.data.organizationCode;
          this.resourceNumberVolumen = response.data.volume;
          this.resourceNumberWeight = response.data.weight;
          this.serviceReservation = response.data.serviceId;
          this.scheludeToken = response.data.scheludeToken;
          this.shippingNumber = response.data.deliveryOrderId;
          this.shippingClient = response.data.senderCode;
          this.shippingService =
            response.data.additionalServices.length == 0
              ? null
              : response.data.additionalServices[0].name;
          this.shippingDestinationPhone = response.data.consigneeTelephone;
          this.reference = response.data.reference1;
          this.senderName = response.data.senderName;
          this.consigneeName = response.data.consigneeName;
        })
        .catch(e => {
          console.log(e);
          this.loadingSlots = false;
          this.$showError();
          return;
        });

      await localhttp
        .post(`${CONTEXT_TIME_SLOTS}/avalible`, {
          deliveryOrderId: this.shippingNumber,
          country: this.countryReservation,
          postalCode: this.postalCodeReservation,
          date: date,
          volume: this.resourceNumberVolumen,
          weight: this.resourceNumberWeight,
          client: this.shippingClient,
          service: this.serviceReservation,
          organizationCode: this.organizationCode
        })
        .then(response => {
          this.availableSlots = response.data;
          this.loadingSlots = false;
        })
        .catch(e => {
          console.log(e);
          this.loadingSlots = false;
          this.$showError();
        });
    },
    selectSlot(slot, date) {
      this.selectedSlot = { ...slot, date };
    },
    async confirmReschedule() {
      if (!this.selectedSlot) return;

      if (
        await this.$root.$confirm(
          this.$t("global.confirm"),
          this.$t("timeSlotsReservations.reschedule.confirmMessage"),
          {
            color: "blue"
          }
        )
      ) {
        this.$root.$loading();

        const method = "/reschelude/" + this.scheludeToken;

        const minutesFrom = hourToMinutes(this.selectedSlot.dateFrom);
        const minutesTo = hourToMinutes(this.selectedSlot.dateTo);
        const dataFormatted = this.transformDate(
          this.selectedSlot.date,
          "YYYY-MM-DD"
        );

        await localhttp
          .post(`${CONTEXT}${method}`, {
            resourceNumberSlots: null,
            resourceNumberWeight: this.resourceNumberWeight,
            resourceNumberVolumen: this.resourceNumberVolumen,
            date: dataFormatted,
            hourFrom: minutesFrom,
            hourTo: minutesTo,
            timeSlotCode: this.selectedSlot.code,
            countryReservation: this.countryReservation,
            postalCodeReservation: this.postalCodeReservation,
            serviceReservation: this.serviceReservation,
            tokenTracking: this.selectedItem.tokenTracking,
            uuid: this.organizationCode === "XPO" ? "0" : null,
            shippingNumber: this.shippingNumber,
            shippingClient: this.shippingClient,
            shippingService: this.shippingService,
            shippingDestinationPhone: this.shippingDestinationPhone,
            reference: this.reference,
            senderName: this.senderName,
            consigneeName: this.consigneeName
          })
          .then(response => {
            this.$root.$loaded();
            console.debug(response.data.token);
            this.closeReschedule();
            this.search();
          })
          .catch(e => {
            console.log(e);
            this.$root.$loaded();
            this.$showErrorCode(e.response.status);
          });
      }
    },
    closeReschedule() {
      this.rescheduleDialog = false;
      this.selectedItem = {};
      this.availableSlots = [];
      this.selectedSlot = null;
      this.selectedDay = null;
    },
    filterExport(jsonData) {
      var vm = this;
      jsonData.forEach(function(v) {
        v.date = transformDate(v.date, vm.$t("global.dateFormat"));
        v.creationDate = transformDate(
          v.creationDate,
          vm.$t("global.dateTimeFormat")
        );
        v.hourFrom = minutesToHour(v.hourFrom);
        v.hourTo = minutesToHour(v.hourTo);
        v.deliveryTime = minutesFormat(v.deliveryTime);
      });
    },
    getReservationTypeText(value) {
      const type = this.reservationTypeValues.find(
        item => item.value === value
      );
      return type ? type.text : value;
    },
    transformDate,
    minutesToHour,
    minutesFormat
  },
  mounted() {
    // Set default dates to today
    const today = new Date().toISOString().slice(0, 10);
    this.filter.dateFrom = today;
    this.filter.dateTo = today;
    this.search();
  }
};
</script>
